module.exports = __webpack_public_path__ + "images/banner-convenios.jpg?ddf9e0ceef204b86d8d91051fc6ad898";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/banner-convenios.jpg
// module id = 993
// module chunks = 0